// Texty stránek Reklamace a Odstoupení (retinoPage.js). Retino portál běží jen
// na CZ — SK dvojče je připravené i pro shop, který ho zatím nemá (S3 #399).
import { CONTACT } from '../../modules/headerTools.js';

export default {
  labelRetino: 'Zajišťuje Retino',
  labelLoadingSub: 'Formulář zpracovává služba Retino',
  labelFailTitle: 'Portál se zatím nenačetl',
  labelFailText:
    'Otevřete si portál v novém okně, nebo stránku načtěte znovu. Když nepomůže ani to, napište nám a vyřídíme to e-mailem.',
  labelFailCta: 'Napsat na ' + CONTACT.email,

  // Popisky dlaždic checklistu podle klíčových slov v obsahu (`re` čte text
  // ADMINISTRACE, ne UI — SK dvojče musí sedět na slovenský text stránky)
  checkMap: [
    { re: /jméno|příjmení/i, icon: 'user', title: 'Jméno a příjmení', desc: 'dle údajů v objednávce' },
    { re: /e-?mail/i, icon: 'mail', title: 'Váš e-mail', desc: 'kontakt z objednávky' },
    { re: /číslo\s+objednávky/i, icon: 'tag', title: 'Číslo objednávky', desc: 'najdete v potvrzení objednávky' },
    { re: /číslo\s+účtu/i, icon: 'card', title: 'Číslo účtu', desc: 'pro vrácení peněz' },
    { re: /předmět/i, icon: 'package', title: 'Předmět reklamace', desc: 'reklamované zboží' },
    { re: /popis|problém/i, icon: 'chat', title: 'Popis problému', desc: 'co a jak se projevuje' },
  ],

  pages: [
    {
      page: 'claim',
      eyebrow: 'Reklamace zboží',
      perex:
        'Reklamaci vyřídíte pohodlně online. Pro co nejrychlejší vyřízení si předem připravte několik údajů. Díky nim reklamaci zpracujeme bez zbytečných dotazů.',
      checkTitle: 'Co si připravte před reklamací',
      portalIcon: 'shield',
      portalTitle: 'Reklamační portál',
      portalSub: 'Online vyřízení reklamace krok za krokem',
      portalLoading: 'Načítáme reklamační portál',
      portalLoadingText:
        'Ve formuláři vyplníte údaje o objednávce a závadě, přiložíte fotky a stav reklamace pak sledujete online.',
      portalCta: 'Zahájit reklamaci online',
      stepsTitle: 'Jak reklamace probíhá',
      steps: [
        { title: 'Vyplňte formulář', desc: 'Zadáte údaje o objednávce a popíšete závadu.' },
        { title: 'Odešlete zboží', desc: 'Zabalíte a pošlete na naši adresu, instrukce dostanete v portálu.' },
        { title: 'Posoudíme reklamaci', desc: 'Zboží přezkoumáme a navrhneme řešení.' },
        { title: 'Vyřízení a vyrozumění', desc: 'O výsledku vás informujeme, obvykle do 30 dnů.' },
      ],
      linkTitle: 'Reklamační řád',
      linkDesc: 'Podmínky a lhůty reklamace',
      helpTitle: 'Nevíte si rady?',
      helpText: 'Poradíme s reklamací i vyplněním. Ozvěte se, rádi pomůžeme.',
    },
    {
      page: 'withdrawal',
      eyebrow: 'Vrácení zboží',
      perex:
        'Nevyhovuje zboží? Můžete od smlouvy odstoupit do 14 dnů od převzetí, bez udání důvodu. Pro rychlé vyřízení si připravte pár údajů níže.',
      stat: {
        num: '14',
        unit: 'dní na vrácení',
        sub: 'bez udání důvodu',
        points: [
          'Lhůta 14 dní od převzetí zásilky',
          'Peníze vrátíme do 14 dní od doručení zboží',
          'Ideálně nepoškozené a kompletní',
        ],
      },
      checkTitle: 'Co si připravte pro odstoupení od smlouvy',
      portalIcon: 'refresh',
      portalTitle: 'Portál pro vrácení zboží',
      portalSub: 'Online odstoupení od smlouvy krok za krokem',
      portalLoading: 'Načítáme portál pro vrácení',
      portalLoadingText:
        'Ve formuláři zadáte údaje o objednávce a číslo účtu pro vrácení peněz. Průběh pak sledujete online.',
      portalCta: 'Zahájit vrácení online',
      stepsTitle: 'Jak vrácení probíhá',
      steps: [
        { title: 'Vyplňte formulář', desc: 'Do 14 dnů od převzetí zboží zadáte údaje o objednávce.' },
        { title: 'Odešlete zboží zpět', desc: 'Zabalíte a pošlete na naši adresu podle instrukcí v portálu.' },
        { title: 'Zkontrolujeme zboží', desc: 'Ověříme stav vráceného zboží.' },
        { title: 'Vrátíme peníze', desc: 'Peníze zašleme na uvedený účet do 14 dnů od doručení zpět.' },
      ],
      linkTitle: 'Obchodní podmínky',
      linkDesc: 'Pravidla odstoupení od smlouvy',
      helpTitle: 'Máte dotaz k vrácení?',
      helpText: 'Rádi poradíme s odstoupením i vyplněním formuláře.',
    },
  ],
};
